<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">飞行中故障后风险评估</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="historyErroyRecord"><img src="@/assets/images/yi.png"/>历史记录</div>
        <div class="decision-head-bt active" @click="$router.push('/index')"><img src="@/assets/images/yi2.png"/>回到首页
        </div>
      </div>
    </div>
    <div class="decision-page">
      <div class="Commitanalogdata-box">
        <div class="Commitanalogdata-left">
          <div class="fauldetails-ul">
            <div class="fauldetails-li">
              <div class="fauldetails-head">航班信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">飞机类别</div>
                  <div class="fauldetails-right">{{ this.handleVO.planeType }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">航班号</div>
                  <div class="fauldetails-right">{{ this.handleVO.flightNo }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">飞机编号</div>
                  <div class="fauldetails-right">{{ this.handleVO.msn }}</div>
                </div>
              </div>
            </div>
            <div class="fauldetails-li">
              <div class="fauldetails-head">故障信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">故障照片</div>
                  <div class="fauldetails-right">
                    <span @click="clickCarousel">查看 ></span>
                  </div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">故障信息</div>
                  <div class="fauldetails-right">{{ this.handleVO.fullFaultMessage }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Commitanalogdata-right">
          <div class="Commitanalogdata-li">
            <div class="fauldetails-head">飞机参数信息</div>
            <div class="parameter-ul">
              <div class="parameter-left">
                当前位置信息
              </div>
              <div class="parameter-right">
                <div class="parameter-li">
                  <div class="parameter-head">
                    latitude 纬度
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.latitude" :disabled="'S0'!==handleVO.state" maxlength="8"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    longitude 经度
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.longitude" :disabled="'S0'!==handleVO.state"  maxlength="8"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    altitute 海拔高度
                  </div>
                  <div class="parameter-input">
                    <div style="float:left;font-size: 14px" v-if="isNum(handleVO.height)">FL</div>
                    <el-input style="font-size: 14px" v-model="handleVO.height" :disabled="'S0'!==handleVO.state" maxlength="8"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    风量
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.air" :disabled="'S0'!==handleVO.state"  maxlength="8"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    温度
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.temperature" :disabled="'S0'!==handleVO.state" maxlength="6"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    真航向
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.trueSailing" :disabled="'S0'!==handleVO.state" maxlength="6"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    校正空速
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.airspeed" :disabled="'S0'!==handleVO.state" maxlength="6"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="parameter-ul">
              <div class="parameter-left">
                飞机重量信息
              </div>
              <div class="parameter-right">
                <div class="parameter-li">
                  <div class="parameter-head">
                    零燃油重量(单位:t)
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.zeroFuelWeight" :disabled="'S0'!==handleVO.state" maxlength="8"
                              placeholder="请输入内容"></el-input>
                    <span>t</span>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    FUFEL 当前燃油重量(单位:t)
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.fuelWeight" :disabled="'S0'!==handleVO.state" maxlength="8"
                              placeholder="请输入内容"></el-input>
                    <span>t</span>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    CG重心
                  </div>
                  <div class="parameter-input">
                    <el-input style="font-size: 14px" v-model="handleVO.cg" :disabled="'S0'!==handleVO.state" maxlength="2"
                              placeholder="请输入内容"></el-input>
                    <span>%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="Commitanalogdata-li">
            <div class="fauldetails-head">备降信息</div>
            <div class="parameter-ul" v-for="(item,index) in handleVO.airports">
              <div class="parameter-left">
                {{ list1[index] }}号备降机场
              </div>
              <div class="parameter-right">
                <div class="parameter-li">
                  <div class="parameter-head">
                    机场代码
                  </div>
                  <div class="parameter-input" style="font-size:14px">
                    <el-select ref="mySelect" v-model="item.airport" placeholder="请选择" @change="handleChange(index)" filterable>
                      <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    到达时间
                  </div>
                  <div class="parameter-input" style="font-size:14px">
                    {{ item.arriveTime }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    (单位：t)
                  </div>
                  <div class="parameter-input" style="font-size:14px">
                    {{ item.arriveWeight }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="Commitanalogdata-bt" @click="commitOpen">确认数据并发送至模拟机</div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible">
        <div class="parameter-modal">
          <div class="parameter-modal-head">请确认您准备提交至模拟机的数据准确无误</div>
          <div class="parameter-modal-box">
            <div class="parameter-ul">
              <div class="parameter-left">
                当前位置信息
              </div>
              <div class="parameter-right">
                <div class="parameter-li">
                  <div class="parameter-head">
                    latitude 纬度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.latitude }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    longitude 经度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.longitude }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    altitute 海拔高度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.height }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    风量
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.air }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    温度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.temperature }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    真航向
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.trueSailing }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    校正空速
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.airspeed }}
                  </div>
                </div>
              </div>
            </div>
            <div class="parameter-ul">
              <div class="parameter-left">
                飞机重量信息
              </div>
              <div class="parameter-right">
                <div class="parameter-li">
                  <div class="parameter-head">
                    零燃油重量(单位:t)
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.zeroFuelWeight }}<span>t</span>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    FUFEL 当前燃油重量(单位:t)
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.fuelWeight }}<span>t</span>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    CG重心
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.cg }}<span>%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="parameter-ul">
              <div class="parameter-left">
                飞机参数信息
              </div>
              <div class="parameter-right" style="display: block;">
                <div v-for="(item,index) in handleVO.airports"
                     style="display: flex;flex-wrap: wrap;justify-content: center;flex:1;">
                  <div class="parameter-li">
                    <div class="parameter-head">
                      备降候选机场{{ index + 1 }}
                    </div>
                    <div class="parameter-name">
                      {{ item.airport }}
                    </div>
                  </div>
                  <div class="parameter-li">
                    <div class="parameter-head">
                      预计到达时间
                    </div>
                    <div class="parameter-name">
                      {{ item.arriveTime }}
                    </div>
                  </div>
                  <div class="parameter-li">
                    <div class="parameter-head">
                      预计到达重量
                    </div>
                    <div class="parameter-name">
                      {{ item.arriveWeight }}
                      <span>t</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fauldetails-bt-box">
            <div class="fauldetails-bt" @click="commitClose">返回编辑</div>
            <div class="fauldetails-bt active" @click="updataHandle">确认并发送至模拟机</div>
          </div>
        </div>
      </el-dialog>
    </div>
    <Carousel v-if="carouselDialog" :showDialog="carouselDialog" @handle-close="closeCarousel" :imgs="imgs"></Carousel>
    <div class="left-box">
      <el-dialog
          :visible="dialogVisible2"
          :before-close="closeHistory"
          @open="planeRiskRecordHistory"
          @close="queryHistory.number=1"
      >
        <div class="history-page">
          <div class="history-head">历史记录</div>
          <div class="history-input">
            <el-input @keyup.enter.native="changeHistoryList()" v-model="paramsHistory.flightNo"
                      placeholder="请输入关键词搜索"></el-input>
          </div>
          <div class="history-ul" @scroll="loadHistory($event)">
            <div class="history-li" v-for="(item,index) in errorRecordHistoryList" :key="item.id">
              <div class="history-top">
                <div class="history-text">
                  <div class="history-h">{{ item.fullFaultMessage }}</div>
                  <div class="history-p">{{ item.createTimeFormat }}</div>
                </div>
                <div class="history-bt" @click="goMalfunction(item)">进入查看</div>
              </div>
              <div class="history-bottom">
                <div class="history-laber">
                  <div class="history-left">记录编号</div>
                  <div class="history-right">{{ item.id }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机类型</div>
                  <div class="history-right">{{ item.planeType }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">航班号</div>
                  <div class="history-right">{{ item.flightNo }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机编号</div>
                  <div class="history-right">{{ item.msn }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">结果</div>
                  <div v-if="item.socReview==='R0'" class="history-right active3">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R1'" class="history-right active4">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R2'" class="history-right active">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R3'" class="history-right active2">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R4'" class="history-right active4">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R5'" class="history-right active">{{ SocReviewEnum[item.socReview] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <confirm-dialog v-if="showConfirmDialog"
                    :visible.sync="showConfirmDialog"
                    :data-row="handleVO"
                    @pass="onPass"
                    @reject="onReject"
    />
  </div>
</template>

<script>
import {airportOptions, getHandle, planeRiskRecordHistory, toAirport, updataHandle} from "@/api/api";
import Carousel from "@/components/Carousel.vue";
import ConfirmDialog from "@/views/Commitanalogdata/components/ConfirmDialog.vue";
import AddTaskDialog from "@/views/Eventhandling/components/AddTaskDialog.vue";

export default {
  name: "decision",
  components: {AddTaskDialog, ConfirmDialog, Carousel},
  data() {
    return {
      showConfirmDialog: false,
      dialogVisible: false,
      dialogVisible2: false,
      carouselDialog: false,
      id: '',
      handleVO: {
        latitude: '',
        longitude: '',
        height: '',
        air: '',
        airports: []
      },
      airportVO: {
        airport: '',
        arriveTime: '',
        arriveWeight: '',
        distance: ''
      },
      param: {
        recordId: ''
      },
      paramS1: {
        recordId: '',
        state: 'S1'
      },
      options: [],
      list1: ["一", "二", "三"],
      query: {
        number: 1,
        limit: 10,
      },
      totalPage: 1,
      params: {},
      airportParams: {},
      errorRecordHistoryList: [],
      isHistory: false,
      isScrollHistory: true,
      SocReviewEnum: {
        R0: "申请中",
        R1: "模拟机处理中",
        R2: "不通过",
        R3: "已反馈",
        R4: "SOC确认信息",
        R5: "系统拒绝"
      },
      queryHistory: {
        number: 1,
        limit: 10,
      },
      paramsHistory: {
        flightNo: "CSN",
        orderBy: JSON.stringify([{"name": "id", "direction": "DESC"}])
      },
    }
  },
  created() {
    this.param.recordId = this.$route.params.id

    //= this.id
    this.getHandle()
    this.loadOptions();
    this.planeRiskRecordHistory()
  },
  methods: {
    async getHandle() {
      const res = await getHandle(this.param)
      console.log(res)
      if (res.code === 'A00000') {
        this.handleVO = res.data[0]
        this.handleVO.airports = this.handleVO.airports||[]
        for (let i = this.handleVO.airports.length; i < 3; i++) {
          this.handleVO.airports.push({
            airport: '',
            arriveTime: '',
            arriveWeight: '',
            distance: ''
          })
        }
        console.log(['\'R0\' === this.handleVO.socReview', this.handleVO.socReview, 'R0' === this.handleVO.socReview])
        this.showConfirmDialog= 'R0' === this.handleVO.socReview
      }
    },
    commitOpen() {
      this.dialogVisible = true
    },
    commitClose() {
      this.dialogVisible = false
    },
    async handleChange(index) {
      this.airportParams.airportCode = this.handleVO.airports[index].airport
      this.airportParams.planId = this.handleVO.planId
      const res = await toAirport(this.airportParams);
      if (res.code === 'A00000') {
        this.handleVO.airports[index].arriveTime = res.data[0].arriveTime
        this.handleVO.airports[index].metar = res.data[0].metar
        this.handleVO.airports[index].arriveWeight = res.data[0].arriveWeight
        this.handleVO.airports[index].distance = res.data[0].leftDistance
      } else {
        this.$message.warning(`无法计算【${this.handleVO.airports[index].airport}】备降机场到达时间：${res.message}`)
      }
    },
    async updataHandle() {
      this.handleVO.state = "S1"
      this.handleVO.airports = this.handleVO.airports.filter(
          item => item.airport !==""
      )
      const res = await updataHandle(this.handleVO)
      if (res.code === 'A00000') {
        this.handleVO = res.data[0]
        this.dialogVisible = false
        this.$router.push(`/simulator/${this.param.recordId}`)
      }
    },
    clickCarousel() {
      this.imgs = this.handleVO.errorImages ? this.handleVO.errorImages : []
      if (this.handleVO.errorMedia) {
        this.handleVO.errorMedia.forEach(media => {
          this.imgs.push(media)
        })
      }
      if (this.imgs.length === 0) {
        this.$message.warning("暂无故障照片/信息");
        return;
      }
      this.carouselDialog = true
    },
    closeCarousel() {
      this.carouselDialog = false
    },

    //
    async loadOptions() {
      const res = await airportOptions()
      this.options = res.data
    },

    loadHistory(e) {
      const sHeight = e.target.scrollHeight
      const sTop = e.target.scrollTop
      const cHeight = e.target.clientHeight
      if (sTop + cHeight + 50 >= sHeight && this.isScrollHistory) {
        this.morePageHistory()
      }
    },
    changeHistoryList() {
      if (this.paramsHistory.flightNo === '') {
        this.paramsHistory.flightNo = null;
      }
      console.log(this.paramsHistory)
      this.errorRecordHistoryList = [];
      this.planeRiskRecordHistory()
    },
    async planeRiskRecordHistory() {
      this.isScrollHistory = false
      const res = await planeRiskRecordHistory(this.queryHistory, this.paramsHistory)
      if (res.code === 'A00000' && res.data.length) {
        if (this.queryHistory.number === 1){
          this.errorRecordHistoryList = res.data
        } else {
          this.errorRecordHistoryList = [...this.errorRecordHistoryList, ...res.data]
        }
        this.isScrollHistory = true
        if (res.data.length < 10) {
          this.isScrollHistory = false
          //  this.$message.info('已全部加载完')
        }
      } else {
        this.isScrollHistory = false
      }
    },
    historyErroyRecord() {
      this.dialogVisible2 = true
    },
    morePageHistory() {
      this.queryHistory.number++
      this.planeRiskRecordHistory()
    },
    goMalfunction(item) {
      // R0: "申请中",
      // R1: "模拟机处理中",
      // R2: "不通过",
      // R3: "已反馈",
      // R4: "SOC确认信息",
      // R5: "系统拒绝"
      if (['R0','R4'].includes(item.socReview)) {
        this.$router.push(`/Commitanalogdata/${item.id}/`)
      } else {
        this.$router.push(`/simulator/${item.id}/`)
      }
    },
    closeHistory() {
      this.dialogVisible2 = false
    },
    isNum(num) {
      return !!(typeof (Number(num)));
    }
    ,onPass(){
      this.getHandle()
    }
    ,onReject(){
      this.$router.push(`/simulator/${this.$route.params.id}/`)
    }
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap")
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /*   scrollHeight 获取元素内容高度(只读)
               scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
              clientHeight 读取元素的可见高度(只读)
                */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight
          // 判断滚动到底部  (condition:如果元素滚动到底, 下面等式返回true, 没有则返回false)
          if (condition) {
            // binding.value 为自定义指令绑定的值，因为绑定的是个方法，所以这里是方法调用，触发指令后执行加载数据
            binding.value()
          }
        })
      }
    }
  },
}
</script>

<style lang="less" scoped>
.parameter-li {
  width: calc(33.3% - 16px);
}

.fauldetails-bt-box {
  position: relative;

  .fauldetails-bt {
    border: 1px solid rgba(255, 255, 255, 0.6);
    color: rgba(255, 255, 255, 0.6);
  }

  .fauldetails-bt.active {
    border: 1px solid #1F60C1;
    color: #fff;
  }
}

/deep/ .left-box .el-dialog__wrapper {
  display: block;

  .el-dialog {
    border-radius: 0;
  }
}

/deep/ .left-box .el-dialog {
  margin: 0 !important;
  background: #262D40;
  height: 100vh;
  width: 600px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }
}

.history-head {
  padding: 24px 16px;
  font-size: 24px;
  text-align: left;
  line-height: 20px;
}

.history-input {
  background: #131B33;
  width: calc(100% - 32px);
  margin: auto;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 8px;

  /deep/ .el-input__inner {
    background: none;
    color: #fff;
  }
}

.history-bottom {
  padding: 24px;

  .history-laber:last-child {
    margin-bottom: 0;
  }

  .history-laber {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .history-left {
      opacity: 0.87;
      font-size: 14px;
    }

    .history-right {
      opacity: 0.9;
      font-size: 16px;
    }

    .history-right.active {
      color: #E07073;
    }

    .history-right.active2 {
      color: #8EBF86;
    }

    .history-right.active3 {
      color: #EBA967;
    }

    .history-right.active4 {
      color: #2769EC;
    }
  }
}

.history-ul {
  padding: 16px;
  border-top: 1px solid #171E2F;
  margin-top: 20px;
  height: calc(100vh - 136px);
  padding-bottom: 0;
  box-sizing: border-box;
  overflow: auto;

  .history-li {
    background: #393F52;
    border: 1px solid #525F89;
    border-radius: 16px;
    margin-bottom: 16px;

    .history-top {
      display: flex;
      padding: 24px;
      justify-content: space-between;
      border-bottom: 1px solid #000000;

      .history-text {
        text-align: left;
        width: 370px;

        .history-h {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.87);
          margin-bottom: 10px;
        }

        .history-p {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
        }
      }

      .history-bt {
        background: #4E5569;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        padding: 0 20px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Commitanalogdata/Commitanalogdata.vue